/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input
} from '@angular/core';
import { API451_CLIENT, ApiClient } from '@element451-libs/api451';
import { ApplicationsApi } from '@element451-libs/models451';
import { get } from '@element451-libs/utils451/get';
import { Application, Progress, getApplicationStatus } from '../../../+state';

type ApplicationItem = Application & { progress: Progress };
@Component({
  selector:
    'button[elm-app-application-list-item], a[elm-app-application-list-item]',
  templateUrl: './application-list-item.component.html',
  styleUrls: ['./application-list-item.component.scss'],
  host: {
    '[attr.aria-label]': 'ariaLabel',
    class: 'elm-application-list-item',
    role: 'button'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationListItemComponent {
  status: string;
  progress: number;
  showProgress: boolean;
  ariaLabel: string;
  subtitle: string;
  statusDecisionLabel: string;

  /**
   * TODO: eventually read this from a setting
   */
  customersThatWantDecisionStatusText = new Set(['dis']);
  showCustomerStatusText = this.customersThatWantDecisionStatusText.has(
    this.api451Client.subdom
  );

  constructor(@Inject(API451_CLIENT) public api451Client: ApiClient) {}

  private _application: ApplicationItem;
  @Input() set application(application: ApplicationItem) {
    this._application = application;

    this.status = getApplicationStatus(application);

    this.progress = Math.round(
      get(this.application, 'progress', 'numericProgress')
    );

    if (
      this.progress === 100 &&
      this.status === ApplicationsApi.ApplicationStatusType.NotSubmitted
    ) {
      this.statusDecisionLabel = 'Not Submitted';
    } else if (application.decision_status.decision_made_at) {
      this.statusDecisionLabel =
        application.decision_status.status_properties?.name;
    } else {
      this.statusDecisionLabel = 'In Review';
    }

    this.progress = Math.round(
      get(this.application, 'progress', 'numericProgress')
    );

    this.showProgress =
      this.application.decision_status.slug ===
        ApplicationsApi.ApplicationStatusType.NotSubmitted &&
      this.progress < 100;

    this.ariaLabel = [this.application.name, this.subtitle]
      .filter(Boolean)
      .join(' - ');

    this.subtitle = [this.application.term.name, this.application.major.name]
      .filter(Boolean)
      .join(' - ');
  }
  get application() {
    return this._application;
  }
}
